<div class="ip-broker-input-select form-floating">
  <mat-select
    multiple
    [formControl]="control"
    class="form-floating-select form-control shadow-none"
    [placeholder]="'IP.SETTLEMENTS.DETAILS.BROKER_NAME' | translate"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="brokerFilter"
        [placeholderLabel]="'IP.SETTLEMENTS.DETAILS.BROKER_NAME' | translate"
        [noEntriesFoundLabel]="'IP.SETTLEMENTS.DETAILS.NO_RESULTS' | translate"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of filteredBroker" [value]="option.id">
      {{ option.fullName ?? option.username }}
    </mat-option>
  </mat-select>
  <label>{{ 'IP.SETTLEMENTS.DETAILS.BROKER_NAME' | translate }}</label>
</div>
